import { MyAccountComponent } from 'components/main/my-account/my-account.component'
export default MyAccountComponent
